var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_54_8",
    "data-name": "Component 54 \\u2013 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.868,
    height: 35.482,
    viewBox: "0 0 29.868 35.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19672",
    "data-name": "Rectangle 19672",
    width: 29.868,
    height: 35.482,
    fill: "#101942"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79980",
    "data-name": "Group 79980",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110679",
    "data-name": "Path 110679",
    d: "M4.158,29.932H25.711a4.162,4.162,0,0,0,4.157-4.158V4.158A4.162,4.162,0,0,0,25.711,0H4.158A4.163,4.163,0,0,0,0,4.158V31.325a4.163,4.163,0,0,0,4.158,4.158H25.711a4.163,4.163,0,0,0,4.157-4.158,6.889,6.889,0,0,1-4.157,1.389H4.158a1.386,1.386,0,1,1,0-2.772Z",
    transform: "translate(0 0)",
    fill: "#273993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110680",
    "data-name": "Path 110680",
    d: "M3.987,5.373A1.388,1.388,0,0,1,5.373,3.987H26.926a1.388,1.388,0,0,1,1.386,1.386V27a1.387,1.387,0,0,1-1.386,1.385H5.373a4.145,4.145,0,0,0-1.386.238Z",
    transform: "translate(-1.215 -1.215)",
    fill: "#e0e7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110681",
    "data-name": "Path 110681",
    d: "M16.929,14.6H14.157a5.019,5.019,0,0,1,1.672-3.734A5.114,5.114,0,0,1,19.8,9.6a5.053,5.053,0,0,1,4.444,4.432,5.607,5.607,0,0,1-1.95,4.576c-.245.246-.47.462-.662.65-.906.863-1.02,1.009-1.02,1.606v.078H17.83v-.07a4.511,4.511,0,0,1,1.88-3.612c.2-.187.4-.38.619-.6.895-.9,1.244-1.593,1.157-2.316a2.264,2.264,0,0,0-1.994-1.985,2.314,2.314,0,0,0-1.819.574,2.212,2.212,0,0,0-.745,1.665Z",
    transform: "translate(-4.316 -2.917)",
    fill: "#273993"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19671",
    "data-name": "Rectangle 19671",
    width: 2.772,
    height: 2.772,
    transform: "translate(13.514 20.096)",
    fill: "#273993"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.701b8dfc3c5a0de1f208d20ebf1bccd1.svg";
export { ForwardRef as ReactComponent };